import React from 'react';
import { AgentDetail } from '../features/agents';

/**
 * AgentDetailPage - Admin agent detail page
 */
export const AgentDetailPage: React.FC = () => {
  return <AgentDetail />;
};

export default AgentDetailPage;
